module.exports = __webpack_public_path__ + "static/media/alu-profili.c6119d98.png";